<template>
  <footer class="footer" role="contentinfo">
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-3">
          <div class="footer-col-1">
            <div id="media_image-2" class="widget_media_image">
              <img
                src="@/assets/img/logo-meta-footer.png"
                class="image wp-image-107 logo-footer attachment-full size-full"
                alt="Logo Meta Footer"
              />
            </div>
            <div id="media_image-3" class="widget_media_image gptw">
              <img
                src="@/assets/img/selo-gptw_1_1-2.png"
                class="image wp-image-108 desktop attachment-full size-full"
                alt="Selo Melhores Empresas Para Trabalhar - Tecnologia de Informação - Great Place To Work - Brasil 2020"
                loading="lazy"
                style="max-width: 100%; height: auto;"
              />
            </div>
          </div>
        </div>
        <div class="col-6 col-md-2">
          <div class="footer-col-2">
            <div id="nav_menu-2" class="widget_nav_menu">
              <h3>Browse</h3>
              <ul id="menu-menu-rodape-navegue" class="menu">
                <li
                  id="menu-item-535"
                  class="menu-item menu-item-type-post_type menu-item-object-page menu-item-535"
                >
                  <a href="https://www.meta.com.br/en/corporate/">Corporate</a>
                </li>
                <li
                  id="menu-item-1049"
                  class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1049"
                >
                  <a href="https://www.meta.com.br/en/cases/">Cases</a>
                </li>
                <li
                  id="menu-item-1048"
                  class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1048"
                >
                  <a href="https://www.meta.com.br/en/events/">Events</a>
                </li>
                <li
                  id="menu-item-1050"
                  class="menu-item menu-item-type-post_type menu-item-object-page menu-item-1050"
                >
                  <a href="https://www.meta.com.br/en/blog/">Blog</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-6 col-md-3">
          <div class="footer-col-3">
            <div id="nav_menu-3" class="widget_nav_menu">
              <h3>Solutions</h3>
              <ul id="menu-menu-rodape-solucoes" class="menu">
                <li
                  id="menu-item-109"
                  class="menu-item menu-item-type-post_type menu-item-object-solucoes menu-item-109"
                >
                  <a
                    href="https://www.meta.com.br/en/solucoes/digital-business/"
                    >Digital Strategy &amp; Solutions</a
                  >
                </li>
                <li
                  id="menu-item-110"
                  class="menu-item menu-item-type-post_type menu-item-object-solucoes menu-item-110"
                >
                  <a
                    href="https://www.meta.com.br/en/solucoes/digital-application-services-sap/"
                    >Management Platforms</a
                  >
                </li>
                <li
                  id="menu-item-111"
                  class="menu-item menu-item-type-post_type menu-item-object-solucoes menu-item-111"
                >
                  <a
                    href="https://www.meta.com.br/en/solucoes/digital-operations-ams/"
                    >Enhanced Performance &amp; Support</a
                  >
                </li>
                <li
                  id="menu-item-112"
                  class="menu-item menu-item-type-post_type menu-item-object-solucoes menu-item-112"
                >
                  <a
                    href="https://www.meta.com.br/en/solucoes/digital-operations-automation-center/"
                    >Process automation &amp; Optimization</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-6 col-md-2">
          <div class="footer-col-4">
            <div id="nav_menu-4" class="widget_nav_menu">
              <h3>Contact</h3>
              <ul id="menu-menu-rodape-contato" class="menu">
                <li
                  id="menu-item-536"
                  class="menu-item menu-item-type-post_type menu-item-object-page menu-item-536"
                >
                  <a href="https://www.metait.ca/#contact-us">Contact</a>
                </li>
                <li
                  id="menu-item-537"
                  class="menu-item menu-item-type-post_type menu-item-object-page menu-item-537"
                >
                  <a href="https://content.metait.ca/talent-database"
                    >Talents</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-6 col-md-2">
          <div class="footer-col-5">
            <div
              id="zoom-social-icons-widget-2"
              class="zoom-social-icons-widget"
            >
              <h3>Follow us</h3>

              <ul
                class="zoom-social-icons-list zoom-social-icons-list--with-canvas zoom-social-icons-list--round zoom-social-icons-list--no-labels"
              >
                <li class="zoom-social_icons-list__item">
                  <a
                    class="zoom-social_icons-list__link"
                    href="https://www.linkedin.com/company/meta-it-north-america/"
                    target="_blank"
                  >
                    <span class="screen-reader-text">linkedin</span>

                    <span
                      class="zoom-social_icons-list-span social-icon socicon"
                      data-hover-rule="background-color"
                      data-hover-color="#0056a8"
                      style="background-color : #00295b; font-size: 15px; padding:7px"
                    >
                      <img src="@/assets/img/linkedin.png" />
                    </span>
                  </a>
                </li>

                <li class="zoom-social_icons-list__item">
                  <a
                    class="zoom-social_icons-list__link"
                    href="https://www.instagram.com/oficial_meta/"
                    target="_blank"
                  >
                    <span class="screen-reader-text">instagram</span>

                    <span
                      class="zoom-social_icons-list-span social-icon socicon"
                      data-hover-rule="background-color"
                      data-hover-color="#0056a8"
                      style="background-color : #00295b; font-size: 15px; padding:7px"
                    >
                      <img src="@/assets/img/instagram.png" />
                    </span>
                  </a>
                </li>

                <li class="zoom-social_icons-list__item">
                  <a
                    class="zoom-social_icons-list__link"
                    href="https://www.facebook.com/metaoficialbr"
                    target="_blank"
                  >
                    <span class="screen-reader-text">facebook</span>

                    <span
                      class="zoom-social_icons-list-span social-icon socicon"
                      data-hover-rule="background-color"
                      data-hover-color="#0056a8"
                      style="background-color : #00295b; font-size: 15px; padding:7px"
                    >
                      <img src="@/assets/img/facebook.png" />
                    </span>
                  </a>
                </li>

                <li class="zoom-social_icons-list__item">
                  <a
                    class="zoom-social_icons-list__link"
                    href="https://www.youtube.com/channel/UC8dSjPVE19268irSO-itupw"
                    target="_blank"
                  >
                    <span class="screen-reader-text">youtube</span>

                    <span
                      class="zoom-social_icons-list-span social-icon socicon"
                      data-hover-rule="background-color"
                      data-hover-color="#0056a8"
                      style="background-color : #00295b; font-size: 15px; padding:7px"
                    >
                      <img src="@/assets/img/youtube.png" />
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="col-6 mob">
          <div id="media_image-3" class="widget_media_image">
            <img
              src="@/assets/img/logo-gptw.png"
              class="image wp-image-108 desktop attachment-full size-full"
              alt="Selo Melhores Empresas Para Trabalhar - Tecnologia de Informação - Great Place To Work - Brasil 2020"
              loading="lazy"
              style="max-width: 100%; height: auto;"
            />
          </div>
        </div>

        <div class="col-6 text-center mob">
          <div
            class="copyright-col-2"
            style="justify-content:start;text-align:left;font-style: normal;font-weight: 300;font-size: 11.058px;line-height: 19px;color:#fff;"
          >
            <div id="custom_html-2" class="widget_text widget_custom_html">
              <div class="textwidget custom-html-widget">
                <ul class="cities">
                  <li>São Paulo</li>
                  <li>Miami</li>
                  <li>Toronto</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>

  <div class="copyright" style="padding: 50px;">
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-4 text-center order-md-2 desk">
          <div class="copyright-col-2">
            <div id="custom_html-2" class="widget_text widget_custom_html">
              <div class="textwidget custom-html-widget">
                <ul class="cities">
                  <li>São Paulo</li>
                  <li>Miami</li>
                  <li>Toronto</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-4 text-center text-md-right order-md-3">
          <div class="copyright-col-3">
            <div id="custom_html-3" class="widget_text widget_custom_html">
              <div class="textwidget custom-html-widget">
                © 2021 Meta. Developed by
                <a
                  href="https://ivoire.com.br"
                  class="ivoire"
                  target="_blank"
                  rel="noopener"
                  >Ivoire</a
                >
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-4 order-md-1">
          <div class="copyright-col-1">
            <div id="text-2" class="widget_text">
              <div class="textwidget">
                <ul>
                  <li>
                    <a href="https://www.meta.com.br/politica-de-privacidade"
                      >Privacy Policy</a
                    >
                  </li>
                  <li>
                    <a href="https://www.meta.com.br/solicite-seus-dados"
                      >Request your data</a
                    >
                  </li>
                  <li>
                    <a
                      href="https://compliance.meta.com.br/"
                      target="_blank"
                      rel="noopener"
                      >Portal Compliance</a
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  components: {},
};
</script>

<style lang="scss">
@media only screen and (min-width: 768px) {
  .footer .container {
    max-width: 1140px !important;
  }

  footer {
    padding: 100px 0;
    font: 300 11px/1.4 "Sora", Helvetica, Arial, sans-serif;
  }

  footer h3 {
    font-size: 13px;
    line-height: 16px;
    margin-bottom: 15px;
  }
  footer ul li {
    margin-bottom: 10px;
  }
  footer ul li a {
    font-size: 12px;
    line-height: 16px;
  }
  footer ul li a {
    font-size: 12px;
    line-height: 16px;
  }
  .copyright {
    background: #000b24;
    font: 300 11px/1.4 "Sora", Helvetica, Arial, sans-serif;
    padding: 40px 0 25px;
  }
  .order-md-1 {
    -ms-flex-order: 1;
    order: 1;
  }
  .order-md-2 {
    -ms-flex-order: 2;
    order: 2;
  }
  .text-md-right {
    text-align: right !important;
  }
  .order-md-3 {
    -ms-flex-order: 3;
    order: 3;
  }
  .copyright {
    background: #000b24;
    padding: 40px 0 25px;
  }
  .copyright-col-2 {
    display: block;
    margin-bottom: 0;
  }
  .copyright-col-3 {
    margin: 0;
  }
  .copyright-col-1 {
    text-align: left;
    border-bottom: 0;
    padding-bottom: 0;
  }

  .copyright .cities li,
  .copyright-col-1 li {
    display: inline-block;
    border-right: solid 1px #ffffff;
    padding-right: 10px;
    margin-left: 10px;
    line-height: 12px;
    margin-bottom: 0;
  }

  .copyright .cities:before {
    top: auto;
    transform: translateY(0);
  }

  .copyright .cities:before {
    content: "";
    position: absolute;
    background: url("../../assets/img/ico_globe.png") no-repeat;
    background-size: cover;
    width: 17px;
    height: 17px;
    left: 25%;
    top: 15%;
    transform: translateY(-50%);
  }
  .copyright .cities li:last-child,
  .copyright-col-1 li:last-child {
    border: 0;
  }
  .copyright .cities li:last-child,
  .copyright-col-1 li:last-child {
    border: 0;
  }
}
.copyright {
  background: #000b24;
  font-size: 12px;
  line-height: 16px;
  color: #ffffff;
}
.copyright a {
  color: #ffffff;
}

.copyright-col-1 {
  text-align: center;
  // padding-bottom: 25px;
}

.copyright-col-1 ul {
  margin: 0;
  padding: 0;
  display: inline-block;
  text-align: left;
  list-style-type: none;
}

.copyright-col-1 ul li {
  margin-bottom: 20px;
}

.copyright .ivoire {
  position: relative;
  padding-right: 25px;
}

.copyright a {
  color: #ffffff;
}

.copyright .ivoire:after {
  content: "";
  position: absolute;
  background: url("../../assets/img/logo_ivoire.png") no-repeat;
  background-size: cover;
  width: 15px;
  height: 12px;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

.copyright-col-2 {
  display: flex;
  align-items: center;
  margin-bottom: 50px;
  justify-content: center;
}

.copyright {
  // background: #001131;
  font-size: 12px;
  line-height: 16px;
  color: #ffffff;
}

footer {
  background: #001131;
  padding: 70px 0;
}
footer h3 {
  color: #56c5c9;
}
footer ul {
  padding: 0;
  margin: 0;
  list-style-type: none;
}
footer ul li a {
  color: #ffffff;
}
.zoom-social-icons-list {
  list-style-type: none;
}
.zoom-social-icons-list {
  margin: 0;
  padding: 0;
}
.zoom-social-icons-list--no-labels .zoom-social_icons-list__item:first-child {
  margin-left: 0 !important;
}
.zoom-social-icons-list--no-labels .zoom-social_icons-list__item {
  display: inline-block;
  margin: 4px;
  border: none;
}
.zoom-social-icons-list--no-labels .zoom-social_icons-list__item {
  margin-top: 0 !important;
}
.zoom-social_icons-list__link {
  text-align: center;
  text-decoration: none !important;
  transition: all 0.2s ease;
}
.screen-reader-text {
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute !important;
  width: 1px;
  word-wrap: normal !important;
}
.zoom-social-icons-list--round .socicon,
.zoom-social-icons-list--round .genericon,
.zoom-social-icons-list--round .academicons,
.zoom-social-icons-list--round .dashicons,
.zoom-social-icons-list--round .fa {
  -moz-border-radius: 100px;
  -webkit-border-radius: 100px;
  border-radius: 100px;
}
.zoom-social-icons-list--with-canvas .socicon,
.zoom-social-icons-list--with-canvas .dashicons,
.zoom-social-icons-list--with-canvas .genericon,
.zoom-social-icons-list--with-canvas .academicons,
.zoom-social-icons-list--with-canvas .fa {
  color: #ffffff;
}
.zoom-social-icons-list .socicon,
.zoom-social-icons-list .dashicons,
.zoom-social-icons-list .genericon,
.zoom-social-icons-list .academicons,
.zoom-social-icons-list .fa {
  padding: 8px;
  -moz-box-sizing: content-box;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
  -moz-transition: opacity 0.2s;
  -webkit-transition: opacity 0.2s;
  transition: opacity 0.2s;
  top: 0px;
  vertical-align: middle;
  width: 1em;
  height: 1em;
  line-height: 1em;
  font-size: 1.2em;
}
.wp-block-wpzoom-blocks-social-icons .socicon,
.zoom-social-icons-widget .socicon {
  font-family: "wpzoom-socicon" !important;
}
.socicon {
  position: relative;
  top: 3px;
  display: inline-block;
  font-family: "wpzoom-socicon";
  font-style: normal;
  font-weight: normal;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 1.2em;
}
footer .logo-footer {
  margin-bottom: 55px;
}
footer ul li a:hover {
  color: #ffffff;
  font-weight: 800;
  text-decoration: none;
}
a:hover,
a:active {
  outline: 0;
}
</style>
